import { Component, OnInit } from '@angular/core';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';

@Component({
  selector: 'app-home-banner',
  templateUrl: './home-banner.component.html',
  styleUrls: ['./home-banner.component.scss']
})
export class HomeBannerComponent implements OnInit {
  public bannerConfig: SwiperConfigInterface = {
    direction: 'horizontal',
    slidesPerView: 1,
    speed: 4000,
    observer: true,
    observeParents: true,
    longSwipes: false,
    freeMode: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: true,
    },
    loop: true,
    lazy: true,
    preloadImages: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  };
  constructor() { }

  ngOnInit(): void {
  }

}
